(() => {
  const ELIGIBLE_PRODUCT_IDS = [];
  const ELIGIBLE_VARIANT_IDS = [
    44560483025179
  ];

  const popup = document.getElementById("PromoCodePopup");
  if (!popup) return;

  const code = popup.dataset.code;
  const copyBtn = document.getElementById("PromoCopyBtn");
  const statusEl = document.getElementById("PromoCopyStatus");

  async function fetchCart() {
    const res = await fetch("/cart.js", { headers: { Accept: "application/json" } });
    return res.json();
  }

  function cartHasEligibleItem(cart) {
    return cart.items.some(item =>
      ELIGIBLE_VARIANT_IDS.includes(Number(item.variant_id)) ||
      ELIGIBLE_PRODUCT_IDS.includes(Number(item.product_id))
    );
  }

  async function evaluate() {
    const cart = await fetchCart();
    if (cartHasEligibleItem(cart)) {
      popup.setAttribute("aria-hidden", "false");
    }
  }

  popup.addEventListener("click", e => {
    if (e.target.hasAttribute("data-close")) {
      popup.setAttribute("aria-hidden", "true");
    }
  });

  copyBtn?.addEventListener("click", async () => {
    await navigator.clipboard.writeText(code);
    statusEl.textContent = "Copied!";
  });

  // 🔑 Catch ALL ajax cart updates
  const origFetch = window.fetch;
  window.fetch = async (...args) => {
    const res = await origFetch(...args);
    if (String(args[0]).includes("/cart")) {
      setTimeout(evaluate, 300);
    }
    return res;
  };

  document.addEventListener("DOMContentLoaded", evaluate);
})();
